import {createSlice} from '@reduxjs/toolkit';

import {componentsBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  error: '',
  products: {
    size: 0,
    total_items: 0,
    total_pages: 0,
    page: 1,
    items: []
  }
};

export const componentsSlicer = createSlice({
  name: 'components',
  initialState,
  reducers: {
    resetProducts(state: any) {
      state.products = initialState.products;
    }
  },
  extraReducers: componentsBuilder
});

export const {resetProducts} = componentsSlicer.actions;
export default componentsSlicer.reducer;
